import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import cls from './ReactErrorFallback.module.css';

interface ReactErrorFallbackProps {
    classes?: string;
    refetchCb?: () => void;
}

export const ReactErrorFallback = ({ classes, refetchCb = null }: ReactErrorFallbackProps) => {
    const { t } = useTranslation();

    const onRefetch = () => {
        if (refetchCb) {
            refetchCb();
            return;
        }
        window.location.reload();
    };

    return (
        <div className={cn(cls.ReactErrorFallback, classes)}>
            <svg
                width="52"
                height="52"
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M37.2818 27.1982L35.1585 29.3216L37.2818 31.4449L34.2182 34.5086L32.0948 32.3852L29.9715 34.5086L26.9078 31.4449L29.0312 29.3216L26.9078 27.1982L29.9715 24.1346L32.0948 26.2579L34.2182 24.1346L37.2818 27.1982ZM17.7818 34.5107L19.9052 32.3874L22.0285 34.5107L25.0922 31.4471L22.9688 29.3237L25.0922 27.2004L22.0285 24.1367L19.9052 26.2601L17.7818 24.1367L14.7182 27.2004L16.8415 29.3237L14.7182 31.4471L17.7818 34.5107ZM17.6518 39.2948L19.838 43.0366C24.0868 40.5536 27.9132 40.5536 32.162 43.0366L34.3482 39.2948C28.7582 36.0252 23.2418 36.0252 17.6518 39.2948ZM9.75 15.1646C10.1769 15.1644 10.5997 15.0802 10.9941 14.9167C11.3884 14.7532 11.7468 14.5136 12.0485 14.2116C12.3503 13.9096 12.5897 13.5511 12.7529 13.1566C12.9162 12.7621 13.0001 12.3394 13 11.9124C12.9999 11.4855 12.9156 11.0627 12.7521 10.6684C12.5886 10.274 12.349 9.91566 12.047 9.61387C11.745 9.31208 11.3865 9.07273 10.9921 8.90947C10.5976 8.74622 10.1748 8.66227 9.74783 8.66241C8.88559 8.6627 8.05878 9.0055 7.44929 9.6154C6.83979 10.2253 6.49755 11.0523 6.49783 11.9146C6.49812 12.7768 6.84092 13.6036 7.45082 14.2131C8.06072 14.8226 8.88776 15.1649 9.75 15.1646ZM18.4167 15.1646C18.8436 15.1644 19.2663 15.0802 19.6607 14.9167C20.0551 14.7532 20.4134 14.5136 20.7152 14.2116C21.017 13.9096 21.2564 13.5511 21.4196 13.1566C21.5829 12.7621 21.6668 12.3394 21.6667 11.9124C21.6665 11.4855 21.5823 11.0627 21.4188 10.6684C21.2553 10.274 21.0157 9.91566 20.7137 9.61387C20.4117 9.31208 20.0532 9.07273 19.6587 8.90947C19.2642 8.74622 18.8414 8.66227 18.4145 8.66241C17.5523 8.6627 16.7254 9.0055 16.116 9.6154C15.5065 10.2253 15.1642 11.0523 15.1645 11.9146C15.1648 12.7768 15.5076 13.6036 16.1175 14.2131C16.7274 14.8226 17.5544 15.1649 18.4167 15.1646ZM52 8.66458V49.8312H0V8.66675C0 5.08308 2.91633 2.16675 6.5 2.16675H45.5C49.0837 2.16675 52 5.08091 52 8.66458ZM4.33333 8.66458V17.3312H47.6667V8.66458C47.6667 7.47075 46.6938 6.49791 45.5 6.49791H6.5C5.30617 6.49791 4.33333 7.47075 4.33333 8.66458ZM47.6667 45.4979V21.6646H4.33333V45.4979H47.6667Z"
                    fill="#D1D9E8"
                />
            </svg>
            <div className={cls.content}>
                <h2>{t('ReactErrorFallback.ReactErrorFallback.content.h2')}</h2>
                <p>{t('ReactErrorFallback.ReactErrorFallback.content.p')}</p>
            </div>
            <button onClick={onRefetch}>{t('ReactErrorFallback.ReactErrorFallback.button')}</button>
        </div>
    );
};
